// MAINTENANCE: shop/account/about/policy links removed while the backend is down.
import React from 'react'
import { withRouter } from 'react-router-dom'
import Instagram from './icons/Instagram'
import Facebook from './icons/Facebook'

class Footer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isUserLoggedIn: false,
    }
  }

  componentDidMount() {
    setTimeout(
      () =>
        this.setState(state => {
          const user = window.Snipcart.api.user.current()
          if (!state.isUserLoggedIn && user != null) {
            return {
              isUserLoggedIn: true,
            }
          } else if (state.isUserLoggedIn && !user) {
            return {
              isUserLoggedIn: false,
            }
          }
          return state
        }),
      1000
    )

    window.Snipcart.subscribe('authentication.success', () =>
      this.setState({ isUserLoggedIn: true })
    )

    window.Snipcart.subscribe('user.loggedout', () =>
      this.setState(state => {
        if (state.isUserLoggedIn) {
          return {
            isUserLoggedIn: false,
          }
        }
        return state
      })
    )
  }

  render() {
    return (
      <footer className="row">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4">
              <h2>Contact</h2>
              <div className="row">
                <div className="col-md-6" style={{ paddingLeft: 0 }}>
                  <ul>
                    <li>1550 W. Horizon Ridge Pkwy.</li>
                    <li>Suite N, Henderson NV, 89012</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul>
                    <li className="d-flex flex-row">
                      <a
                        href="https://www.instagram.com/dogfood2mydoor/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Instagram />
                      </a>
                      <a
                        href="https://www.facebook.com/dogfood2mydoor/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="ml-2"
                      >
                        <Facebook />
                      </a>
                    </li>
                    <li>
                      <a href="tel:7029712484">(702) 971-2484</a>
                    </li>
                    <li>
                      <a href="mailto:info@dogfood2mydoor.com">
                        info@dogfood2mydoor.com
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 center-block copyright">
          <p>
            <span>{new Date().getFullYear()}</span>
            <span> Dog Food 2 My Door </span>|<span> All Rights Reserved </span>
          </p>
        </div>
      </footer>
    )
  }
}

export default withRouter(Footer)
